import React,{useEffect} from 'react';
import './App.css';
import ROUTES from './Config/routes';
import AOS from "aos";

function App() {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <>
      <ROUTES />
    </>
  );
}

export default App;

